
(function () {
  // mobile nav
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) burger.addEventListener('click', function () { nav.classList.toggle('open'); });

  // quantity steppers
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = b.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
  });

  // PDP gallery
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (main && src) main.src = src;
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  // variant picker -> hidden id + price
  document.querySelectorAll('[data-variants]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var form = sel.closest('form');
      if (!form) return;
      var idInput = form.querySelector('[name="id"]');
      if (idInput) idInput.value = opt.value;
      var price = document.querySelector('[data-price]');
      if (price && opt.dataset.price) price.innerHTML = opt.dataset.price;
      var btn = form.querySelector('[data-atc]');
      if (btn) {
        var avail = opt.dataset.available === 'true';
        btn.disabled = !avail;
        btn.textContent = avail ? btn.dataset.labelAdd : btn.dataset.labelSold;
      }
    });
  });

  // sticky buy bar
  var bar = document.querySelector('[data-stickybar]');
  var anchor = document.querySelector('[data-atc-anchor]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('on', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80% 0px' }).observe(anchor);
  }
  var barBtn = document.querySelector('[data-stickybar-btn]');
  if (barBtn) barBtn.addEventListener('click', function () {
    var f = document.querySelector('[data-product-form]');
    if (f) f.querySelector('[data-atc]').click();
  });
})();
